// removed by extract-text-webpack-plugin
module.exports = {"errorRow":"_3uRjp _3PU7Z","header":"_2K5k6 _3t_1_","row":"ud95c _32f2G","customForm":"_1Uczv","buttonContainer":"_2uvVz _25En3","button":"_3K7Kb I9zSN","notificationContainer":"_33yE_"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/style.css
// module id = 899
// module chunks = 0